import React from 'react'
import sprite from '../../assets/img/sprite.svg'

interface Props {
  name: string
  viewBox: string
  width?: string
  height?: string
}

const Icon = (props: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={props.width ? props.width : undefined}
      height={props.height ? props.height : undefined}
      viewBox={props.viewBox}
    >
      <use xlinkHref={`${sprite}#${props.name}`} />
    </svg>
  )
}

export default Icon

export const PrinterIcon = () => <Icon name='printer' viewBox='0 0 48 48' />
export const OSWindowsIcon = () => <Icon name='os-win' viewBox='0 0 48 48' />
export const OSLinuxIcon = ({ height }: { height?: string }) => (
  <Icon name='os-linux' viewBox='0 0 24 24' height={height} />
)
export const OSMacIcon = () => <Icon name='os-apple' viewBox='0 0 24 24' />
export const AccountIcon = () => <Icon name='id' viewBox='0 0 35 35' />
export const HeartRateIcon = () => <Icon name='heartrate' viewBox='0 0 46 46' />
export const TickIcon = () => <Icon name='tick' viewBox='0 0 18 18' />
export const LockIcon = () => <Icon name='lock' viewBox='0 0 16 21' />
export const GlobeIcon = () => <Icon name='globe' viewBox='0 0 19 19' />
export const PeopleIcon = () => <Icon name='people' viewBox='0 0 21 13' />
export const PeopleManIcon = () => <Icon name='people-man' viewBox='0 0 24 24' />
export const MagicIcon = () => <Icon name='magic' viewBox='0 0 24 24' />
export const CloudFileIcon = () => <Icon name='cloud-file' viewBox='0 0 24 24' />
export const BriefcaseIcon = () => <Icon name='briefcase' viewBox='0 0 45 45' />
export const ContactIcon = () => <Icon name='contact' viewBox='0 0 35 35' />
export const ErrorIcon = () => <Icon name='error' viewBox='0 0 18 18' />
export const WarningIcon = () => <Icon name='exclaim' viewBox='0 0 20 20' />
export const ServerIcon = () => <Icon name='server' viewBox='0 0 48 48' />
export const ExclaimIcon = () => <Icon name='exclaim' viewBox='0 0 20 20' />
export const PaperCutIcon = () => <Icon name='papercut' viewBox='0 0 18 24' />
export const FindMeIcon = () => <Icon name='findme' viewBox='0 0 17 24' />
export const ByodIcon = () => <Icon name='byod' viewBox='0 0 73 47' />
export const CloudPrintIcon = () => <Icon name='cloud-print' viewBox='0 0 64 86' />
export const DeForestIcon = () => <Icon name='deforest' viewBox='0 0 22 24' />
export const CO2Icon = () => <Icon name='co2' viewBox='0 0 46 53' />
export const ChargeIcon = () => <Icon name='charge' viewBox='0 0 48 48' />
export const UserIcon = () => <Icon name='people' viewBox='0 0 21 13' />
export const ScannerIcon = () => <Icon name='scanner' viewBox='0 0 24 24' />
export const RemoteWarningIcon = () => <Icon name='remote-warning' viewBox='0 0 21 20' />
export const RemoteManageIcon = () => <Icon name='remote-manage' viewBox='0 0 21 20' />
export const DisconnectIcon = () => <Icon name='disconnect' viewBox='0 0 17 20' />
export const AnyEnvironment = () => <Icon name='any-environment' viewBox='0 0 24 24' />
export const RemoteRocket = () => <Icon name='remote-rocket' viewBox='0 0 24 24' />
export const Insights = () => <Icon name='insights' viewBox='0 0 24 24' />
export const ClipboardIcon = () => <Icon name='paper-write' viewBox='0 0 24 24' />
export const LinkCustomerIcon = () => <Icon name='download-thick-box' viewBox='0 0 24 24' />
export const EmailReadIcon = () => <Icon name='email-action-read-document' viewBox='0 0 24 24' />
export const CalendarIcon = () => <Icon name='calendar' viewBox='0 0 29 32' />
export const LightningIcon = () => <Icon name='thunder' viewBox='0 0 20 24' />
export const HelpIcon = () => <Icon name='help' viewBox='0 0 22 22' />
export const InfoIcon = () => <Icon name='info' viewBox='0 0 6 12' />
export const ConstructionSign = () => <Icon name='construction-sign' viewBox='0 0 24 24' />
export const MegaphoneIcon = () => <Icon name='megaphone' viewBox='0 0 19 20' />
export const MeshIcon = () => <Icon name='mesh' viewBox='0 0 48 48' />
export const DisconnectedIcon = () => <Icon name='heart-stop' viewBox='0 0 46 10' />
export const GiftIcon = () => <Icon name='gift' viewBox='0 0 24 24' />
export const BellIcon = () => <Icon name='bell' viewBox='0 0 24 24' />
export const PiggyBankIcon = () => <Icon name='pig' viewBox='0 0 32 32' />
export const AccountManagerIcon = () => <Icon name='pre-sales' viewBox='0 0 32 20' />
export const AdminCrownIcon = () => <Icon name='crown' viewBox='0 0 32 32' />
export const TechServicesIcon = () => <Icon name='tech-support' viewBox='0 0 32 32' />
export const AdminIcon = () => <Icon name='admin' viewBox='0 0 32 26' />
export const CustomersIcon = () => <Icon name='ids' viewBox='0 0 24 24' />
export const BlinkIcon = () => <Icon name='blink' viewBox='0 0 24 24' />
export const GroupIcon = () => <Icon name='group' viewBox='0 0 24 24' />
export const BooksIcon = () => <Icon name='books' viewBox='0 0 24 24' />
export const ShopIcon = () => <Icon name='shop' viewBox='0 0 24 24' />
export const LicenseIcon = () => <Icon name='license' viewBox='0 0 24 24' />
export const TrialLicenseIcon = () => <Icon name='license-trial' viewBox='0 0 24 24' />
export const NFRLicenseIcon = () => <Icon name='license-nfr' viewBox='0 0 24 24' />
export const QuestionIcon = () => <Icon name='question' viewBox='0 0 7 12' />
export const BarChartIcon = () => <Icon name='barchart' viewBox='0 0 24 24' />
export const HostedIcon = () => <Icon name='hosted' viewBox='0 0 24 24' />
export const CloudHostedIcon = () => <Icon name='cloud-hosted' viewBox='0 0 28 23' />
export const EdgeMeshIcon = () => <Icon name='edge-mesh' viewBox='0 0 48 48' />
export const HiveLogoIcon = () => <Icon name='hive' viewBox='0 0 32 28' />
export const PocketLogoIcon = () => <Icon name='pocket' viewBox='0 0 32 32' />
export const NoBellIcon = () => <Icon name='no-bell' viewBox='0 0 16 16' />
export const EventIcon = () => <Icon name='event' viewBox='0 0 18 20' />
export const SunIcon = () => <Icon name='sun' viewBox='0 0 32 32' />
export const MoonIcon = () => <Icon name='moon' viewBox='0 0 32 31' />

export const LanyardIcon = () => (
  <svg
    className='lanyard'
    width='26px'
    height='26px'
    viewBox='0 0 26 26'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M19,1 L1.98828125,24.234375 C6.55940271,17.7992553 14.5306238,11.7266698 24.7031739,6.3046879'
        id='Path'
        stroke='#e3e7eb'
        strokeWidth='2.5'
      />
    </g>
  </svg>
)

export const LanyardBGIcon = () => (
  <svg
    className='lanyard-bg'
    width='392px'
    height='272px'
    viewBox='0 0 392 272'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M196.988281,71.234375 C201.559403,64.7992553 209.530624,58.7266698 219.703174,53.3046879 C269.82434,26.5900437 373.385649,15.6696525 387,55 C396,81 388,140 335,172 C282,204 143.44463,268.796172 70.6835938,270.023438 C41.9108886,270.508749 15.7047293,262.182238 6,240 C-1,224 -5,192 60.7578125,186.246094 C126.515625,180.492188 133.316034,180.667748 160,179 C176,178 271.088937,177.879706 315.972656,145.46875 C345.696421,124.00494 395.028875,59.3300032 364.554688,25.34375 C323,-21 240.85419,11.1593637 214,48 L196.988281,71.234375 Z'
        id='Path-2'
        stroke='#e3e7eb'
        strokeWidth='2.5'
      />
    </g>
  </svg>
)

const FeatureGaugeIcon = (level: number) => (
  <svg
    className='gauge'
    xmlns='http://www.w3.org/2000/svg'
    height='46'
    width='46'
    viewBox='0 0 200 200'
    data-value='90'
  >
    <path className='bg' stroke='#CFD9E0' d='M41 149.5a77 77 0 1 1 117.93 0' fill='none' />
    <path
      className='meter'
      stroke='#26AA27'
      d='M41 149.5a77 77 0 1 1 117.93 0'
      fill='none'
      strokeDasharray='350'
      strokeDashoffset={level}
    />
  </svg>
)

export const AdvancedFeatureGaugeIcon = () => FeatureGaugeIcon(34.9518)
export const StandardFeatureGaugeIcon = () => FeatureGaugeIcon(174.759)
export const BasicFeatureGaugeIcon = () => FeatureGaugeIcon(244.662)
export const UpgradeGaugeIcon = () => (
  <svg className='gauge' xmlns='http://www.w3.org/2000/svg' height='46' width='46' viewBox='0 0 200 200' data-value='0'>
    <path className='bg' stroke='#CFD9E0' d='M41 149.5a77 77 0 1 1 117.93 0' fill='none' />
  </svg>
)

export const MessagesIcon = () => <Icon name='messages' viewBox='0 0 27 24' />
export const CertificateIcon = () => <Icon name='cert' viewBox='0 0 24 24' />
export const TagIcon = () => <Icon name='tag' viewBox='0 0 24 24' />
export const MfdSmallIcon = () => <Icon name='mfd-sml' viewBox='0 0 24 24' />
export const ReceiptIcon = () => <Icon name='receipt' viewBox='0 0 20 24' />
export const HourglassIcon = () => <Icon name='hourglass' viewBox='0 0 18 24' />
export const MfdIcon = () => <Icon name='mfd' viewBox='0 0 32 32' />
export const LaptopIcon = () => <Icon name='laptop' viewBox='0 0 32 26' />
export const TechIcon = () => <Icon name='tech' viewBox='0 0 24 23' />
export const LockIconSmall = () => <Icon name='lock' viewBox='0 0 16 21' width='12px' height='12px' />
export const PasswordIcon = () => <Icon name='password' viewBox='0 0 32 21' />
export const EncryptIcon = () => <Icon name='encrypt' viewBox='0 0 26 32' />
export const EnabledIcon = () => <Icon name='enabled' viewBox='0 0 18 19' />
export const DisabledIcon = () => <Icon name='disabled' viewBox='0 0 18 18' />
export const CircledPlusIcon = () => <Icon name='circled-plus' viewBox='-1 -1 24 24' />
export const HyperlinkIcon = () => <Icon name='hyperlink' viewBox='-1 -1 24 24' />
export const HeroIcon = () => <Icon name='hero' viewBox='0 0 24 24' />

export const AISparklesIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinejoin='round'>
      <path d='M 9 5 Q 9 12 16 12 Q 9 12 9 19 Q 9 12 2 12 Q 9 12 9 5 Z' />
      <path d='M 19 2 Q 19 5 22 5 Q 19 5 19 8 Q 19 5 16 5 Q 19 5 19 2 Z' />
      <path d='M 19 16 Q 19 19 22 19 Q 19 19 19 22 Q 19 19 16 19 Q 19 19 19 16 Z' />
    </g>
  </svg>
)

export const NoData = () => (
  <svg viewBox='-1 -1 24 24'>
    <path
      d='M2.40625 3.728083333333333V2.40625a1.3218333333333332 1.3218333333333332 0 0 1 1.3218333333333332 -1.3218333333333332H5.050833333333333'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='M2.40625 18.271916666666666v1.3218333333333332a1.3218333333333332 1.3218333333333332 0 0 0 1.3218333333333332 1.3218333333333332H5.050833333333333'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='M19.59375 18.271916666666666v1.3218333333333332a1.3218333333333332 1.3218333333333332 0 0 1 -1.3218333333333332 1.3218333333333332H16.949166666666663'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m12.321833333333332 20.915583333333334 1.9836666666666667 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m7.6945 20.915583333333334 1.9836666666666667 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m12.321833333333332 1.0844166666666666 1.9836666666666667 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m7.6945 1.0844166666666666 1.9836666666666667 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m2.40625 9.017249999999999 0 -1.9836666666666667'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m2.40625 14.966416666666667 0 -1.9836666666666667'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m19.59375 9.017249999999999 0 -1.9836666666666667'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m19.59375 14.966416666666667 0 -1.9836666666666667'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='m16.949166666666663 3.0671666666666666 1.32275 1.3218333333333332'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
  </svg>
)

export const OfficePrinterIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
      <path d='M0.75 9.75V7.5A1.5 1.5 0 0 1 2.25 6h19.5a1.5 1.5 0 0 1 1.5 1.5v0.75a1.5 1.5 0 0 1 -1.5 1.5Z' />
      <path d='M3.75 6 21.29 0.75' />
      <path d='M0.75 9.75v12.52a1 1 0 0 0 1 1h20.52a1 1 0 0 0 1 -1v-7.54a1 1 0 0 0 -1 -1h-2.93l-2 1.5H13.5V9.75' />
      <path d='m0.75 19.25 22.5 0' />
      <path d='m13.5 15.25 -1.99 0' />
      <path d='m3.75 12.75 0 2.25' />
      <path d='m6.75 12.75 0 2.25' />
    </g>
  </svg>
)

export const EarthIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
      <path d='M0.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0 -22.5 0' />
      <path d='M9.88 23.05c-1.57 -2.2 -2.63 -6.33 -2.63 -11S8.31 3.15 9.88 1' />
      <path d='M14.12 23.05c1.57 -2.2 2.63 -6.33 2.63 -11S15.69 3.15 14.12 1' />
      <path d='m0.75 12 22.5 0' />
      <path d='m2.05 17.25 19.9 0' />
      <path d='m2.05 6.75 19.9 0' />
    </g>
  </svg>
)

export const CalendarClockIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
      <path d='M8.25 17.25h-6a1.5 1.5 0 0 1 -1.5 -1.5v-12a1.5 1.5 0 0 1 1.5 -1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v4.5' />
      <path d='m0.75 6.75 16.5 0' />
      <path d='m5.25 3.75 0 -3' />
      <path d='m12.75 3.75 0 -3' />
      <path d='M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0 -12 0Z' />
      <path d='m19.902 17.25 -2.652 0 0 -2.651' />
    </g>
  </svg>
)

/* the customer lifecycle: arrows turning round a point (the stage the customer is at) */
export const LifecycleIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
      <path d='M3.75 12a8.25 8.25 0 0 1 14.57 -5.3' />
      <path d='M18.75 2.25v4.5h-4.5' />
      <path d='M20.25 12a8.25 8.25 0 0 1 -14.57 5.3' />
      <path d='M5.25 21.75v-4.5h4.5' />
      <path d='M10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0Z' />
    </g>
  </svg>
)

export const LicenseManagerIcon = () => (
  <svg viewBox='-0.5 0 25 25' xmlns='http://www.w3.org/2000/svg'>
    <g
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth='1.5'
    >
      <path d='m16.2504 16.8657 -0.8 5.9558c-0.1 0.7066 0.7 1.2113 1.3 0.7066l2 -2.0189 2 2.0189c0.5 0.5047 1.4 0.1009 1.3 -0.7066l-0.8 -5.9558' />
      <path d='M18.75 17.6299c2.4853 0 4.5 -2.0147 4.5 -4.5s-2.0147 -4.50002 -4.5 -4.50002 -4.5 2.01472 -4.5 4.50002 2.0147 4.5 4.5 4.5Z' />
      <path d='M18.75 12.73c-0.2 0 -0.4 0.2 -0.4 0.4s0.2 0.4 0.4 0.4' />
      <path d='M18.7499 12.73c0.2 0 0.4 0.2 0.4 0.4s-0.2 0.4 -0.4 0.4' />
      <path d='M11.75 23.75h-10c-0.6 0 -1 -0.4 -1 -1V2.25c0 -0.6 0.4 -1 1 -1h10.1c0.2 0 0.5 0.10002 0.7 0.30002l4.9 4.39999' />
      <path d='M5.1499 7.75h6.6' />
      <path d='M5.1499 12.75h6.6' />
      <path d='M5.1499 17.75h5' />
    </g>
  </svg>
)

export const OfficeBuildingIcon = () => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth='1.5'
    >
      <path d='M23.25 23.25H0.75' />
      <path d='M0.75 23.25V1.75c0 -0.6 0.4 -1 1 -1h14c0.6 0 1 0.4 1 1v21.5' />
      <path d='M16.75 10.25h5.5c0.6 0 1 0.4 1 1v12' />
      <path d='M7 3.75H4v4h3v-4Z' />
      <path d='M13.5 3.75h-3v4h3v-4Z' />
      <path d='M7 11.25H4v4h3v-4Z' />
      <path d='M13.5 11.25h-3v4h3v-4Z' />
      <path d='M6.94995 23.2499v-3.3c0 -1 0.8 -1.8 1.8 -1.8s1.80005 0.8 1.80005 1.8v3.3' />
    </g>
  </svg>
)

// Outlined PaperCut bubble. Same path the sprite's `papercut` symbol uses, but
// rendered with stroke instead of fill so it matches the other outline icons.
export const PaperCutOutlineIcon = () => (
  <svg width='24' height='32' viewBox='0 0 24 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 1H23V16C23 19.866 19.866 23 16 23H7.58594L1 29.5859V8C1 4.13403 4.134 1 8 1ZM7.5 17H16.5V8H7.5V17Z'
      stroke='currentColor'
      strokeWidth='2'
    />
  </svg>
)

export const NotesIcon = () => (
  <svg viewBox='-1 -1 24 24'>
    <path
      d='M12.49325 21.3125H2.0625a1.375 1.375 0 0 1 -1.375 -1.375v-16.5a1.375 1.375 0 0 1 1.375 -1.375h17.875a1.375 1.375 0 0 1 1.375 1.375v9.05575a1.375 1.375 0 0 1 -0.40241666666666664 0.9716666666666667l-7.445166666666666 7.445166666666666a1.375 1.375 0 0 1 -0.9716666666666667 0.40241666666666664Z'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
    <path
      d='M13.0625 21.18875V14.4375a1.375 1.375 0 0 1 1.375 -1.375h6.75125'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
    <path
      d='m4.8125 0.6875 0 2.75'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
    <path
      d='m17.1875 0.6875 0 2.75'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
    <path
      d='m4.8125 7.5625 11 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
    <path
      d='m4.8125 11.6875 4.8125 0'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='1.5'
    ></path>
  </svg>
)

export const CurrencyIcon = () => (
  <svg viewBox='0 0 24 24'>
    <g>
      <path
        d='M0.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0 -22.5 0'
        fill='none'
        stroke='currentColor'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-width='1.5'
      ></path>
      <g>
        <path
          d='M15 7.5h-4.21A1.66 1.66 0 0 0 9 9.29c0 2 6 3.46 6 5.42a1.76 1.76 0 0 1 -1.79 1.79H9'
          fill='none'
          stroke='currentColor'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='1.5'
        ></path>
        <path
          d='m12 7.5 0 -2.25'
          fill='none'
          stroke='currentColor'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='1.5'
        ></path>
        <path
          d='m12 18.75 0 -2.25'
          fill='none'
          stroke='currentColor'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='1.5'
        ></path>
      </g>
    </g>
  </svg>
)

export const KeyInsightsIcon = () => (
  <svg viewBox='0 0 24 24' fill='none'>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M4.59993 23.25v-6.265c-1.38177 -1.2801 -2.34542 -2.9471 -2.76512 -4.7833 -0.41969 -1.8362 -0.27593 -3.75636 0.41253 -5.50962 0.68845 -1.75326 1.88959 -3.25818 3.44657 -4.31823S9.09134 0.747884 10.9749 0.750006c7.139 0 8.68 5.878004 11.225 12.479994 0.0436 0.1137 0.0589 0.2362 0.0447 0.3571 -0.0143 0.1209 -0.0578 0.2365 -0.1266 0.3369 -0.0689 0.1003 -0.1612 0.1824 -0.2688 0.2392 -0.1077 0.0568 -0.2275 0.0866 -0.3493 0.0868h-1.9v3c0 0.7957 -0.316 1.5587 -0.8787 2.1213 -0.5626 0.5626 -1.3256 0.8787 -2.1213 0.8787h-1.5v3'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M8.11072 7.92413C10.314 7.4812 12.088 5.6857 12.5316 3.42542c0.4436 2.26028 2.2171 4.05578 4.4204 4.49871m0 0.00257c-2.2033 0.44293 -3.9773 2.2384 -4.4209 4.4987 -0.4436 -2.2603 -2.2171 -4.05577 -4.42038 -4.4987'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M4.63232 13.4823c1.24604 -0.2461 2.24925 -1.2436 2.50013 -2.4993 0.25087 1.2557 1.25384 2.2532 2.49987 2.4993m0 0.0014c-1.24603 0.2461 -2.24924 1.2436 -2.50012 2.4993 -0.25087 -1.2557 -1.25384 -2.2532 -2.49988 -2.4993'
      strokeWidth='1.5'
    />
  </svg>
)

export const LightbulbIcon = () => (
  <svg viewBox='-0.8 -0.8 16 16' width='16'>
    <path
      d='M10.665100800000001 8.3248128c-0.00005760000000000001 -0.6305040000000001 -0.17215200000000003 -1.2490416000000002 -0.49772160000000004 -1.7889840000000004 -0.32556960000000007 -0.5399280000000001 -0.7923024000000001 -0.9808128 -1.3498848 -1.2751344000000002 -0.5575968000000001 -0.29430720000000005 -1.1849184000000001 -0.4309200000000001 -1.8144000000000002 -0.3950928000000001 -0.6294816000000001 0.035812800000000006 -1.2372624 0.24271200000000004 -1.7578656000000001 0.598392 -0.5206032 0.3556656 -0.9343008 0.8466480000000001 -1.1965104000000002 1.4200416000000002 -0.26222400000000007 0.5733792000000001 -0.363024 1.20744 -0.29155680000000006 1.8338832000000003 0.07146720000000001 0.6264432000000001 0.31249440000000006 1.2215088 0.6971328000000001 1.7210880000000002 0.07812000000000001 0.10147680000000002 0.16156800000000002 0.19823040000000003 0.24988320000000003 0.2899296 0.6261984000000002 0.6501744000000002 1.2357360000000002 1.4183568000000002 1.2357360000000002 2.3210640000000002v0c0 0.33418080000000006 0.29583360000000003 0.6300144000000001 0.6300288 0.6300144000000001h1.2600432000000001c0.33418080000000006 0 0.6300288 -0.29583360000000003 0.6300288 -0.6300144000000001v0c0 -0.9027504000000001 0.6094224 -1.6710336000000001 1.2356064000000002 -2.3212944 0.13354560000000001 -0.13867200000000002 0.255888 -0.28883520000000007 0.36545760000000005 -0.4492512 0.39340800000000004 -0.5759424000000001 0.6039072000000001 -1.2571632000000001 0.6040224000000001 -1.9546416000000004Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
    <path
      d='M7.200000000000001 0.7200000000000001V1.4400000000000002'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
    <path
      d='m2.6179056000000003 2.6179056000000003 0.50976 0.50976'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
    <path
      d='M0.7200000000000001 7.200000000000001H1.4400000000000002'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
    <path
      d='M13.680000000000001 7.200000000000001H12.96'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
    <path
      d='m11.782080000000002 2.6179056000000003 -0.50976 0.50976'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
  </svg>
)

// Add these exports to Icons.tsx

export const CoffeeBrewingIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' id='Coffee-Filter--Streamline-Ultimate' {...props}>
    <style>{`
      svg {
        overflow: visible;
      }
      .steam-1 {
        animation: steam 2s infinite ease-in-out;
        animation-delay: 0s;
        transform-origin: 7.125px 2.625px;
      }
      .steam-2 {
        animation: steam 2s infinite ease-in-out;
        animation-delay: 0.5s;
        transform-origin: 10.875px 2.625px;
      }
      .steam-3 {
        animation: steam 2s infinite ease-in-out;
        animation-delay: 1s;
        transform-origin: 14.625px 2.625px;
      }

      @keyframes steam {
        0% { opacity: 0; transform: translateY(2px) scaleY(0.8); }
        50% { opacity: 0.8; }
        100% { opacity: 0; transform: translateY(-4px) scaleY(1.1); }
      }

      .drip {
        animation: drip-drop 1.6s infinite cubic-bezier(0.4, 0, 0.6, 1);
        transform-origin: 10.875px 11.25px;
      }

      @keyframes drip-drop {
        0% { opacity: 0; transform: translateY(0) scale(0.6, 0.6); }
        20% { opacity: 1; transform: translateY(1px) scale(0.9, 1.3); }
        70% { opacity: 1; transform: translateY(7.5px) scale(0.8, 1.1); }
        90% { opacity: 0.2; transform: translateY(9px) scale(1.4, 0.3); }
        100% { opacity: 0; transform: translateY(9px) scale(0, 0); }
      }
    `}</style>
    <path
      d='m7.125 11.25 -2.068 8.272a3 3 0 0 0 2.91 3.728h5.816a3 3 0 0 0 2.91 -3.728l-2.068 -8.272'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <path
      d='m4.875 11.25 12 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <path
      d='m7.125 11.25 -1.5 -3.75 10.5 0 -1.5 3.75'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <path
      d='M15.375 14.25h2.25a1.5 1.5 0 0 1 1.5 1.5v2.2a1.5 1.5 0 0 1 -0.668 1.248l-1.673 1.116'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <circle className='drip' cx={10.875} cy={11.25} r={0.8} fill='currentColor' />
    <path
      className='steam-1'
      d='M7.125 0.75c-1.5 1.5 1.5 2.25 0 3.75'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <path
      className='steam-2'
      d='M10.875 0.75c-1.5 1.5 1.5 2.25 0 3.75'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
    <path
      className='steam-3'
      d='M14.625 0.75c-1.5 1.5 1.5 2.25 0 3.75'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1}
    />
  </svg>
)

export const PaperDocumentIcon = () => (
  <svg fill='none' viewBox='-1 -1 24 24'>
    <path
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      d='M2.0625 2.520833333333333v16.958333333333332c0 1.01255 0.8208108333333333 1.8333333333333333 1.8333333333333333 1.8333333333333333h14.208333333333332c1.01255 0 1.8333333333333333 -0.8207833333333333 1.8333333333333333 -1.8333333333333333V7.44425c-0.00009166666666666667 -0.3644208333333333 -0.14483333333333334 -0.7139 -0.40241666666666664 -0.9716666666666667L14.153333333333332 1.0899166666666666c-0.12778333333333333 -0.12766416666666666 -0.2794 -0.22890724999999998 -0.4462333333333333 -0.29795425000000003C13.540175 0.7229144999999999 13.361333333333333 0.6874184166666666 13.18075 0.6875H3.895833333333333c-1.0125225 0 -1.8333333333333333 0.8208108333333333 -1.8333333333333333 1.8333333333333333'
      stroke-width='1.5'
    ></path>
    <path
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      d='M19.815766666666665 6.875018333333333H15.125c-0.36465 0 -0.7144499999999999 -0.14486083333333333 -0.9723083333333332 -0.4027283333333333C13.894833333333333 6.214431666666666 13.75 5.864695833333333 13.75 5.500018333333333V0.8092443333333333'
      stroke-width='1.5'
    ></path>
  </svg>
)

export const FeaturesUnderutilizedIcon = () => (
  <svg viewBox='-1 -1 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m0.8799999999999999 6.34425 9.625 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m5.6925 0.8442500000000001 -4.8125 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='M18.755 15.281749999999999h1.9845833333333334a0.3446666666666667 0.3446666666666667 0 0 1 0.25666666666666665 0.5729166666666666l-4.74925 5.342333333333333a0.3428333333333333 0.3428333333333333 0 0 1 -0.4995833333333333 0.014666666666666666l-5.343249999999999 -5.342333333333333a0.3446666666666667 0.3446666666666667 0 0 1 0.24291666666666667 -0.5875833333333333h2.6079166666666667v-6.875c0 -4.73275 -1.309 -7.5625 -7.5625 -7.5625h8.433333333333332c3.24225 0 4.631916666666666 2.0744166666666666 4.631916666666666 4.631916666666666Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

export const MonoVolumeIcon = () => (
  <svg viewBox='-1 -1 24 24' xmlns='http://www.w3.org/2000/svg'>
    <circle
      cx='11'
      cy='11'
      r='10'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.93 18.07 L18.07 3.93'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.6 20.4 L20.4 7.6'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11 21 L21 11'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ColorVolumeIcon = () => (
  <svg viewBox='-1 -1 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.6875 11a10.3125 10.3125 0 1 0 20.625 0 10.3125 10.3125 0 1 0 -20.625 0Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='M7.5625 11a3.4375 3.4375 0 1 0 6.875 0 3.4375 3.4375 0 1 0 -6.875 0Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m12.329166666666666 14.171666666666667 2.655583333333333 6.339666666666667'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m7.828333333333332 12.329166666666666 -6.339666666666667 2.655583333333333'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='M9.67175 7.82925 7.015249999999999 1.4886666666666668'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m14.171666666666667 9.670833333333334 6.339666666666667 -2.655583333333333'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m9.697416666666667 14.18175 -2.605166666666667 6.361666666666666'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m7.81825 9.697416666666667 -6.361666666666666 -2.605166666666666'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m12.302583333333333 7.81825 2.605166666666667 -6.361666666666666'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m14.18175 12.302583333333333 6.361666666666666 2.605166666666667'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

export const FleetPerformanceSectionIcon = () => (
  <svg viewBox='0 0 24 24'>
    <path
      d='m0.75 23.25 6.53 -5.224a3 3 0 0 1 2.2 -0.639l4.946 0.549a2.985 2.985 0 0 0 1.121 -0.087l7.7 -2.1'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='m0.75 17.25 6.787 -4.073a3 3 0 0 1 1.544 -0.427h5.269a3.007 3.007 0 0 0 1.242 -0.269L23.25 9'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
    <path
      d='M0.75 11.25 8.8 7.226a3 3 0 0 1 1.993 -0.245L15 7.917a3 3 0 0 0 2.643 -0.686l5.6 -4.981v21H0.75V0.75'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

export const SupportServiceSectionIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M3 18v-6a9 9 0 0 1 18 0v6' />
    <path d='M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z' />
  </svg>
)

export const FeatureUtilizationSectionIcon = () => (
  <svg fill='none' viewBox='0 0 24 24'>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M12.0001 4.5c-1.4888 0.01125 -2.96074 0.31565 -4.33185 0.89582 -1.37111 0.58017 -2.6145 1.42474 -3.65918 2.48549C2.96439 8.94205 2.13889 10.1982 1.57971 11.578s-0.841086 2.8562 -0.829618 4.345V18c0 0.3978 0.158036 0.7794 0.439338 1.0607 0.28131 0.2813 0.66284 0.4393 1.06066 0.4393H21.7501c0.3978 0 0.7793 -0.158 1.0607 -0.4393 0.2813 -0.2813 0.4393 -0.6629 0.4393 -1.0607v-2.08c0.0224 -3.0062 -1.1503 -5.8981 -3.2601 -8.03975C17.8803 5.73862 15.0063 4.52272 12.0001 4.5Z'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9 19.5v-0.75c0 -0.7956 0.31607 -1.5587 0.87868 -2.1213C10.4413 16.0661 11.2044 15.75 12 15.75c0.7956 0 1.5587 0.3161 2.1213 0.8787 0.5626 0.5626 0.8787 1.3257 0.8787 2.1213v0.75'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M14.25 9.00293 12 15.7529'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M4.875 15.75c-0.20711 0 -0.375 -0.1679 -0.375 -0.375S4.66789 15 4.875 15'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M4.875 15.75c0.20711 0 0.375 -0.1679 0.375 -0.375S5.08211 15 4.875 15'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M6.375 12.0029c-0.20711 0 -0.375 -0.1679 -0.375 -0.375s0.16789 -0.375 0.375 -0.375'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M6.375 12.0029c0.20711 0 0.375 -0.1679 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M9.375 9.00293c-0.20711 0 -0.375 -0.16789 -0.375 -0.375s0.16789 -0.375 0.375 -0.375'
      strokeWidth='1.5'
    />
    <path
      stroke='currentColor'
      d='M9.375 9.00293c0.20711 0 0.375 -0.16789 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375'
      strokeWidth='1.5'
    />
    <g>
      <path
        stroke='currentColor'
        d='M17.625 12c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375'
        strokeWidth='1.5'
      />
      <path
        stroke='currentColor'
        d='M17.625 12c0.2071 0 0.375 -0.1679 0.375 -0.375s-0.1679 -0.375 -0.375 -0.375'
        strokeWidth='1.5'
      />
    </g>
    <g>
      <path
        stroke='currentColor'
        d='M19.125 15.7529c-0.2071 0 -0.375 -0.1679 -0.375 -0.375s0.1679 -0.375 0.375 -0.375'
        strokeWidth='1.5'
      />
      <path
        stroke='currentColor'
        d='M19.125 15.7529c0.2071 0 0.375 -0.1679 0.375 -0.375s-0.1679 -0.375 -0.375 -0.375'
        strokeWidth='1.5'
      />
    </g>
  </svg>
)

export const DocumentSvg = () => (
  <svg
    width='163px'
    height='163px'
    viewBox='0 0 163 163'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <defs>
      <polygon
        id='path-1'
        points='0.550198953 0.113089005 1.38789529 0.113089005 1.38789529 40.4213613 0.550198953 40.4213613'
      />
      <polygon
        id='path-3'
        points='0.431581152 0.113089005 1.26927749 0.113089005 1.26927749 40.4213613 0.431581152 40.4213613'
      />
      <polygon
        id='path-5'
        points='0.312544503 0.113089005 1.15024084 0.113089005 1.15024084 40.4213613 0.312544503 40.4213613'
      />
      <polygon
        id='path-7'
        points='0.193507853 0.113089005 1.03120419 0.113089005 1.03120419 40.4213613 0.193507853 40.4213613'
      />
      <polygon
        id='path-9'
        points='0.0745549738 0.113089005 0.912251309 0.113089005 0.912251309 40.4213613 0.0745549738 40.4213613'
      />
      <polygon
        id='path-11'
        points='0.79321466 0.113089005 1.63091099 0.113089005 1.63091099 40.4213613 0.79321466 40.4213613'
      />
      <polygon
        id='path-13'
        points='0.67417801 0.113089005 1.51187435 0.113089005 1.51187435 40.4213613 0.67417801 40.4213613'
      />
      <polygon
        id='path-15'
        points='0.520209424 0.57382199 46.0783246 0.57382199 46.0783246 45.8729215 0.520209424 45.8729215'
      />
      <polygon
        id='path-17'
        points='0.520209424 0.57382199 52.2031414 0.57382199 52.2031414 51.798534 0.520209424 51.798534'
      />
      <polygon
        id='path-19'
        points='0.520209424 0.57382199 58.328377 0.57382199 58.328377 57.7238115 0.520209424 57.7238115'
      />
      <polygon
        id='path-21'
        points='0.520209424 0.57382199 64.4536126 0.57382199 64.4536126 63.6490052 0.520209424 63.6490052'
      />
      <polygon
        id='path-23'
        points='0.520209424 0.57382199 70.5784293 0.57382199 70.5784293 69.5742827 0.520209424 69.5742827'
      />
      <polygon
        id='path-25'
        points='0.520209424 0.57382199 76.7036649 0.57382199 76.7036649 75.4994764 0.520209424 75.4994764'
      />
      <polygon
        id='path-27'
        points='0.520209424 0.57382199 81.2171728 0.57382199 81.2171728 81.2707853 0.520209424 81.2707853'
      />
      <polygon
        id='path-29'
        points='0.520209424 0.57382199 81.2171728 0.57382199 81.2171728 81.2707853 0.520209424 81.2707853'
      />
      <polygon
        id='path-31'
        points='0.520209424 0.57382199 81.2171728 0.57382199 81.2171728 81.2707853 0.520209424 81.2707853'
      />
      <polygon
        id='path-33'
        points='0.578931937 0.154554974 80.3794764 0.154554974 80.3794764 78.7576963 0.578931937 78.7576963'
      />
      <polygon
        id='path-35'
        points='0.00217801047 0.215874346 73.6779058 0.215874346 73.6779058 72.893822 0.00217801047 72.893822'
      />
      <polygon
        id='path-37'
        points='0.263539267 0.277277487 67.8140314 0.277277487 67.8140314 67.0299476 0.263539267 67.0299476'
      />
      <polygon
        id='path-39'
        points='0.524984293 0.338596859 61.9501571 0.338596859 61.9501571 61.1660733 0.524984293 61.1660733'
      />
      <polygon id='path-41' points='0.785926702 0.4 56.0862827 0.4 56.0862827 55.302199 0.785926702 55.302199' />
      <polygon
        id='path-43'
        points='0.209591623 0.461319372 49.384712 0.461319372 49.384712 49.4383246 0.209591623 49.4383246'
      />
      <polygon
        id='path-45'
        points='0.470534031 0.522638743 43.5208377 0.522638743 43.5208377 43.5744503 0.470534031 43.5744503'
      />
    </defs>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Group-127'>
        <g id='Group-31' transform='translate(0.000000, 0.326702)'>
          <path
            d='M40.729801,123.241047 C45.7677068,123.241047 45.7677068,127.848377 50.8056126,127.848377 C55.8426806,127.848377 55.8426806,123.241047 60.878911,123.241047 C65.9184921,123.241047 65.9184921,127.848377 70.9580733,127.848377 C75.9984921,127.848377 75.9984921,123.241047 81.0380733,123.241047'
            id='Stroke-1'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M40.729801,129.863288 C45.7677068,129.863288 45.7677068,134.46978 50.8056126,134.46978 C55.8426806,134.46978 55.8426806,129.863288 60.878911,129.863288 C65.9184921,129.863288 65.9184921,134.46978 70.9580733,134.46978 C75.9984921,134.46978 75.9984921,129.863288 81.0380733,129.863288'
            id='Stroke-3'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M40.729801,136.485529 C45.7677068,136.485529 45.7677068,141.092021 50.8056126,141.092021 C55.8426806,141.092021 55.8426806,136.485529 60.878911,136.485529 C65.9184921,136.485529 65.9184921,141.092021 70.9580733,141.092021 C75.9984921,141.092021 75.9984921,136.485529 81.0380733,136.485529'
            id='Stroke-5'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M40.729801,143.107351 C45.7677068,143.107351 45.7677068,147.714681 50.8056126,147.714681 C55.8426806,147.714681 55.8426806,143.107351 60.878911,143.107351 C65.9184921,143.107351 65.9184921,147.714681 70.9580733,147.714681 C75.9984921,147.714681 75.9984921,143.107351 81.0380733,143.107351'
            id='Stroke-7'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M40.729801,149.729592 C45.7677068,149.729592 45.7677068,154.336921 50.8056126,154.336921 C55.8426806,154.336921 55.8426806,149.729592 60.878911,149.729592 C65.9184921,149.729592 65.9184921,154.336921 70.9580733,154.336921 C75.9984921,154.336921 75.9984921,149.729592 81.0380733,149.729592'
            id='Stroke-9'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M40.729801,156.351749 C45.7677068,156.351749 45.7677068,160.958241 50.8056126,160.958241 C55.8426806,160.958241 55.8426806,156.351749 60.878911,156.351749 C65.9184921,156.351749 65.9184921,160.958241 70.9580733,160.958241 C75.9984921,160.958241 75.9984921,156.351749 81.0380733,156.351749'
            id='Stroke-11'
            stroke='#C7E3A2'
            strokeWidth='3.437'
          />
          <path
            d='M121.426764,121.618848 L81.1184921,121.618848 C81.1184921,99.3570681 99.1649843,81.3097382 121.426764,81.3097382 L121.426764,121.618848 Z'
            id='Fill-13'
            fill='#00C2AC'
          />
          <path
            d='M121.426764,121.452398 L121.426764,161.76067 C99.1649843,161.76067 81.1184921,143.714178 81.1184921,121.452398 L121.426764,121.452398 Z'
            id='Fill-15'
            fill='#70BC1E'
          />
          <path
            d='M40.729801,60.0609005 C30.0709529,60.0609005 21.4309529,51.4200628 21.4309529,40.7612147 C21.4309529,30.1032042 30.0709529,21.4623665 40.729801,21.4623665 C51.3886492,21.4623665 60.0286492,30.1032042 60.0286492,40.7612147 C60.0286492,51.4200628 51.3886492,60.0609005 40.729801,60.0609005 M40.729801,0.53252356 C18.5124188,0.53252356 0.501109948,18.5438325 0.501109948,40.7612147 C0.501109948,62.9785969 18.5124188,80.9899058 40.729801,80.9899058 C62.9471832,80.9899058 80.9584921,62.9785969 80.9584921,40.7612147 C80.9584921,18.5438325 62.9471832,0.53252356 40.729801,0.53252356'
            id='Fill-17'
            fill='#BBE7C2'
          />
          <path
            d='M80.9584084,121.578806 C80.9584084,99.3614241 62.9479372,81.3501152 40.7297173,81.3501152 C18.5123351,81.3501152 0.501026178,99.3614241 0.501026178,121.578806 L21.4308691,121.578806 C21.4308691,110.919958 30.0708691,102.279958 40.7297173,102.279958 C51.3885654,102.279958 60.0285654,110.919958 60.0285654,121.578806 L80.9584084,121.578806 Z'
            id='Fill-19'
            fill='#00A900'
          />
          <path
            d='M121.426764,159.990534 C142.618806,159.990534 159.798283,142.811058 159.798283,121.618178'
            id='Stroke-21'
            stroke='#008715'
            strokeWidth='4.695'
          />
          <path
            d='M121.426764,152.916356 C127.629906,152.916356 133.410848,151.111958 138.274513,147.999079 C146.963937,142.437613 152.723937,132.701068 152.723937,121.618346'
            id='Stroke-23'
            stroke='#008715'
            strokeWidth='4.695'
          />
          <path
            d='M121.426764,145.842513 C126.227602,145.842513 130.702576,144.446073 134.466346,142.036859 C141.192209,137.731937 145.650429,130.196021 145.650429,121.618848'
            id='Stroke-25'
            stroke='#008715'
            strokeWidth='4.695'
          />
          <path
            d='M121.426764,138.768335 C124.825298,138.768335 127.993466,137.779853 130.658178,136.074304 C135.419644,133.026764 138.576084,127.691476 138.576084,121.618178'
            id='Stroke-27'
            stroke='#008715'
            strokeWidth='4.695'
          />
          <path
            d='M121.426764,131.694157 C123.422995,131.694157 125.284356,131.113634 126.85001,130.111749 C129.647079,128.321592 131.501738,125.186094 131.501738,121.618346'
            id='Stroke-29'
            stroke='#008715'
            strokeWidth='4.695'
          />
        </g>
        <g id='Group-75' transform='translate(0.837696, 121.792670)'>
          <g id='Group-54' transform='translate(36.020942, 0.000000)'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1' />
            </mask>
            <g id='Clip-53' />
            <line
              x1='0.96904712'
              y1='69.528712'
              x2='0.96904712'
              y2='-27.941445'
              id='Stroke-52'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-2)'
            />
          </g>
          <g id='Group-57' transform='translate(30.157068, 0.000000)'>
            <mask id='mask-4' fill='white'>
              <use xlinkHref='#path-3' />
            </mask>
            <g id='Clip-56' />
            <line
              x1='0.850429319'
              y1='69.528712'
              x2='0.850429319'
              y2='-27.941445'
              id='Stroke-55'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-4)'
            />
          </g>
          <g id='Group-60' transform='translate(24.293194, 0.000000)'>
            <mask id='mask-6' fill='white'>
              <use xlinkHref='#path-5' />
            </mask>
            <g id='Clip-59' />
            <line
              x1='0.73139267'
              y1='69.528712'
              x2='0.73139267'
              y2='-27.941445'
              id='Stroke-58'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-6)'
            />
          </g>
          <g id='Group-63' transform='translate(18.429319, 0.000000)'>
            <mask id='mask-8' fill='white'>
              <use xlinkHref='#path-7' />
            </mask>
            <g id='Clip-62' />
            <line
              x1='0.612356021'
              y1='69.528712'
              x2='0.612356021'
              y2='-27.941445'
              id='Stroke-61'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-8)'
            />
          </g>
          <g id='Group-66' transform='translate(12.565445, 0.000000)'>
            <mask id='mask-10' fill='white'>
              <use xlinkHref='#path-9' />
            </mask>
            <g id='Clip-65' />
            <line
              x1='0.493403141'
              y1='69.528712'
              x2='0.493403141'
              y2='-27.941445'
              id='Stroke-64'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-10)'
            />
          </g>
          <g id='Group-69' transform='translate(5.863874, 0.000000)'>
            <mask id='mask-12' fill='white'>
              <use xlinkHref='#path-11' />
            </mask>
            <g id='Clip-68' />
            <line
              x1='1.21206283'
              y1='69.528712'
              x2='1.21206283'
              y2='-27.941445'
              id='Stroke-67'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-12)'
            />
          </g>
          <g id='Group-72'>
            <mask id='mask-14' fill='white'>
              <use xlinkHref='#path-13' />
            </mask>
            <g id='Clip-71' />
            <line
              x1='1.09302618'
              y1='69.528712'
              x2='1.09302618'
              y2='-27.941445'
              id='Stroke-70'
              stroke='#27AA27'
              strokeWidth='3.437'
              mask='url(#mask-14)'
            />
          </g>
        </g>
        <polygon
          id='Fill-76'
          fill='#00A800'
          points='40.8099686 121.905508 0.500858639 162.21378 0.500858639 121.905508'
        />
        <g id='Group-126' transform='translate(40.209424, 0.326702)'>
          <g id='Group-80'>
            <mask id='mask-16' fill='white'>
              <use xlinkHref='#path-15' />
            </mask>
            <g id='Clip-79' />
            <line
              x1='46.0783246'
              y1='-50.6598534'
              x2='-53.7089005'
              y2='45.8729215'
              id='Stroke-78'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-16)'
            />
          </g>
          <g id='Group-83'>
            <mask id='mask-18' fill='white'>
              <use xlinkHref='#path-17' />
            </mask>
            <g id='Clip-82' />
            <line
              x1='52.2031414'
              y1='-44.7342408'
              x2='-47.5840838'
              y2='51.798534'
              id='Stroke-81'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-18)'
            />
          </g>
          <g id='Group-86'>
            <mask id='mask-20' fill='white'>
              <use xlinkHref='#path-19' />
            </mask>
            <g id='Clip-85' />
            <line
              x1='58.328377'
              y1='-38.8089634'
              x2='-41.4588482'
              y2='57.7238115'
              id='Stroke-84'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-20)'
            />
          </g>
          <g id='Group-89'>
            <mask id='mask-22' fill='white'>
              <use xlinkHref='#path-21' />
            </mask>
            <g id='Clip-88' />
            <line
              x1='64.4536126'
              y1='-32.8837696'
              x2='-35.3336126'
              y2='63.6490052'
              id='Stroke-87'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-22)'
            />
          </g>
          <g id='Group-92'>
            <mask id='mask-24' fill='white'>
              <use xlinkHref='#path-23' />
            </mask>
            <g id='Clip-91' />
            <line
              x1='70.5784293'
              y1='-26.9584921'
              x2='-29.2087958'
              y2='69.5742827'
              id='Stroke-90'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-24)'
            />
          </g>
          <g id='Group-95'>
            <mask id='mask-26' fill='white'>
              <use xlinkHref='#path-25' />
            </mask>
            <g id='Clip-94' />
            <line
              x1='76.7036649'
              y1='-21.0332984'
              x2='-23.0835602'
              y2='75.4994764'
              id='Stroke-93'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-26)'
            />
          </g>
          <g id='Group-98'>
            <mask id='mask-28' fill='white'>
              <use xlinkHref='#path-27' />
            </mask>
            <g id='Clip-97' />
            <line
              x1='82.8285654'
              y1='-15.1080209'
              x2='-16.9586597'
              y2='81.4247539'
              id='Stroke-96'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-28)'
            />
          </g>
          <g id='Group-101'>
            <mask id='mask-30' fill='white'>
              <use xlinkHref='#path-29' />
            </mask>
            <g id='Clip-100' />
            <line
              x1='88.953801'
              y1='-9.18282723'
              x2='-10.8334241'
              y2='87.3499476'
              id='Stroke-99'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-30)'
            />
          </g>
          <g id='Group-104'>
            <mask id='mask-32' fill='white'>
              <use xlinkHref='#path-31' />
            </mask>
            <g id='Clip-103' />
            <line
              x1='95.0786178'
              y1='-3.25754974'
              x2='-4.70860733'
              y2='93.2752251'
              id='Stroke-102'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-32)'
            />
          </g>
          <g id='Group-107' transform='translate(0.837696, 2.513089)'>
            <mask id='mask-34' fill='white'>
              <use xlinkHref='#path-33' />
            </mask>
            <g id='Clip-106' />
            <line
              x1='100.366157'
              y1='0.154554974'
              x2='0.578931937'
              y2='96.6873298'
              id='Stroke-105'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-34)'
            />
          </g>
          <g id='Group-110' transform='translate(7.539267, 8.376963)'>
            <mask id='mask-36' fill='white'>
              <use xlinkHref='#path-35' />
            </mask>
            <g id='Clip-109' />
            <line
              x1='99.7894031'
              y1='0.215874346'
              x2='0.00217801047'
              y2='96.7486492'
              id='Stroke-108'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-36)'
            />
          </g>
          <g id='Group-113' transform='translate(13.403141, 14.240838)'>
            <mask id='mask-38' fill='white'>
              <use xlinkHref='#path-37' />
            </mask>
            <g id='Clip-112' />
            <line
              x1='100.050764'
              y1='0.277277487'
              x2='0.263539267'
              y2='96.8100524'
              id='Stroke-111'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-38)'
            />
          </g>
          <g id='Group-116' transform='translate(19.267016, 20.104712)'>
            <mask id='mask-40' fill='white'>
              <use xlinkHref='#path-39' />
            </mask>
            <g id='Clip-115' />
            <line
              x1='100.312209'
              y1='0.338596859'
              x2='0.524984293'
              y2='96.8713717'
              id='Stroke-114'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-40)'
            />
          </g>
          <g id='Group-119' transform='translate(25.130890, 25.968586)'>
            <mask id='mask-42' fill='white'>
              <use xlinkHref='#path-41' />
            </mask>
            <g id='Clip-118' />
            <line
              x1='100.573152'
              y1='0.4'
              x2='0.785926702'
              y2='96.9327749'
              id='Stroke-117'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-42)'
            />
          </g>
          <g id='Group-122' transform='translate(31.832461, 31.832461)'>
            <mask id='mask-44' fill='white'>
              <use xlinkHref='#path-43' />
            </mask>
            <g id='Clip-121' />
            <line
              x1='99.9968168'
              y1='0.461319372'
              x2='0.209591623'
              y2='96.9940942'
              id='Stroke-120'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-44)'
            />
          </g>
          <g id='Group-125' transform='translate(37.696335, 37.696335)'>
            <mask id='mask-46' fill='white'>
              <use xlinkHref='#path-45' />
            </mask>
            <g id='Clip-124' />
            <line
              x1='100.257759'
              y1='0.522638743'
              x2='0.470534031'
              y2='97.0554136'
              id='Stroke-123'
              stroke='#A1DAA6'
              strokeWidth='2.545'
              mask='url(#mask-46)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const HealthCheckIcon = () => (
  <svg fill='none' viewBox='-1 -1 24 24'>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m14.712866666666665 0.9811175000000001 -7.425265833333333 0 0 6.3062724999999995h-6.306483333333333v7.425293333333333h6.306483333333333l0 6.306208333333333 7.425265833333333 0v-6.306208333333333h6.306024999999999V7.28739h-6.306024999999999V0.9811175000000001Z'
      strokeWidth='1.5'
    />
  </svg>
)

export const BrewingProcessIcon = () => (
  <svg viewBox='0 0 100 100'>
    <path
      d='m37.619 60.774 4.082 0 0 4.082 -3.13 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M41.7 60.774h2.4a2.723 2.723 0 0 1 2.435 1.5l3.438 6.88a2.721 2.721 0 0 1 0.06 2.308l-3.533 8.09a2.721 2.721 0 0 1 -2.5 1.63h-0.26a2.041 2.041 0 0 1 -2.04 -2.041h0a2.04 2.04 0 0 1 2.041 -2.04h0a0.806 0.806 0 0 0 0.792 -0.671l1.248 -7.493 -2.721 -4.081H41.7Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M18.847 56.963s-2.255 -3.574 -1.338 -4.567a2.45 2.45 0 0 0 -0.139 -3.462 2.421 2.421 0 0 0 -1.009 -0.55 3.263 3.263 0 1 0 -5.311 1.381Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='m29.052 58 -0.728 -2.55a1.213 1.213 0 0 1 0.438 -1.3 3.425 3.425 0 0 1 4.109 0 1.212 1.212 0 0 1 0.437 1.3l-0.73 2.55'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M25.374 74.379h10.884V77.1H25.374z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M37.46 89.345H24.173a1.359 1.359 0 0 1 -1.352 -1.51l1.057 -9.524a1.362 1.362 0 0 1 1.353 -1.21H36.4a1.361 1.361 0 0 1 1.352 1.21l1.059 9.524a1.361 1.361 0 0 1 -1.351 1.51Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M38.98 60.774H20.732a1.066 1.066 0 0 0 -0.846 1.715l3.378 4.411 0.614 6.125a1.5 1.5 0 0 0 1.5 1.353h10.881a1.5 1.5 0 0 0 1.5 -1.352Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M37.619 59.848a1.362 1.362 0 0 0 -1.095 -1.334h0a29.133 29.133 0 0 0 -11.417 0h0a1.361 1.361 0 0 0 -1.093 1.334v0.926h13.605Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M55.306 26.164V28.8a2.721 2.721 0 1 0 0 5.442c0.057 0 0.111 -0.013 0.166 -0.017a13.588 13.588 0 0 0 26.878 0c0.057 0 0.11 0.017 0.167 0.017a2.721 2.721 0 1 0 0 -5.442v-2.636'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M76.345 30.11a2.218 2.218 0 0 0 -4.093 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M65.472 30.11a2.217 2.217 0 0 0 -4.092 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M64.769 38a5.935 5.935 0 0 0 8.186 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M79.97 26.164a12.205 12.205 0 0 0 0.369 4.971 2.348 2.348 0 0 1 2.178 -2.335v-2.636'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M55.306 26.164V28.8a2.347 2.347 0 0 1 2.177 2.339 12 12 0 0 0 0.423 -4.45'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M82.739 26.164c0.364 -1.04 1.633 -2.132 1.633 -3.265 0 -6.762 -6.944 -12.244 -15.51 -12.244s-15.51 5.482 -15.51 12.245c0 1.133 1.269 2.225 1.633 3.265Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M79.474 23.658c-2.37 -1.445 -6.235 -2.391 -10.612 -2.391s-8.242 0.946 -10.613 2.391'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='m89.995 68.253 0 10.204'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M49.342 60.362a21.35 21.35 0 0 1 6.639 -8.776'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M81.837 78.461V51.593a21.132 21.132 0 0 0 -3.111 -2.005'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M59.677 49.293a21.2 21.2 0 0 0 -3.691 2.3v26.868'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M78.435 51.014a5.205 5.205 0 0 0 -5.2 -5.206h-8.641a5.207 5.207 0 0 0 -4.894 6.985l1.843 5.07a1.361 1.361 0 0 0 1.979 0.7l5.389 -3.233 5.389 3.235a1.36 1.36 0 0 0 1.979 -0.7l1.844 -5.07a5.212 5.212 0 0 0 0.312 -1.781Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='m68.912 55.332 0 23.129'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M73.674 44.95v4.493a2.718 2.718 0 0 1 -0.8 1.924l-3.964 3.965 -3.965 -3.965a2.721 2.721 0 0 1 -0.8 -1.924v-4.492'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M71.633 69.618a0.68 0.68 0 1 0 1.36 0 0.68 0.68 0 1 0 -1.36 0Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M71.633 75.06a0.68 0.68 0 1 0 1.36 0 0.68 0.68 0 1 0 -1.36 0Z'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M90 68.257a21.055 21.055 0 0 0 -8.163 -16.664'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M68.912 66.216 64.628 57.9'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='m73.195 57.9 -4.283 8.314'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='m47.818 76.525 0 -0.013'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)

// the AI stars, one in each colour of the AI gradient: green, teal and purple
export const ChatbotSparklesIcon = () => (
  <svg height='48' viewBox='-1 -1 48 48' width='48'>
    <path
      d='M31.864583333333336 26.303950000000004c-9.559758333333335 3.221533333333334 -12.711256666666667 6.808575 -15.041616666666668 15.742733333333334 -2.33036 -8.934158333333333 -5.481800833333334 -12.5212 -15.041605166666669 -15.742733333333334C11.341165833333335 23.082608333333337 14.492606666666667 19.49556666666667 16.82296666666667 10.561312500000001c2.33036 8.934254166666665 5.481858333333333 12.521295833333333 15.041616666666668 15.7426375Z'
      fill='#27AA27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M43.723958333333336 11.400659166666667c-5.392541666666666 1.80987 -7.170058333333333 3.825264166666667 -8.4847 8.8447075 -1.31445 -5.019443333333333 -3.0921583333333333 -7.0348375 -8.484508333333334 -8.8447075 5.39235 -1.80987 7.170058333333333 -3.825264166666667 8.484508333333334 -8.844784166666667 1.3146416666666667 5.01952 3.0921583333333333 7.034914166666667 8.4847 8.844784166666667Z'
      fill='#32C2AF'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M44.424883333333334 37.49421666666667c-3.9912666666666663 1.3113833333333333 -5.307058333333333 2.7718833333333333 -6.280150000000001 6.409141666666667 -0.9729000000000001 -3.6372583333333335 -2.288691666666667 -5.097758333333333 -6.280150000000001 -6.409141666666667 3.9914583333333336 -1.3115750000000002 5.307250000000001 -2.7718833333333333 6.280150000000001 -6.409141666666667 0.9730916666666668 3.6372583333333335 2.288883333333333 5.097566666666667 6.280150000000001 6.409141666666667Z'
      fill='#AB87FF'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const NoChatIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M23.25 0.75 0.75 23.25'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='M20.75 8.75v7.833a1.166 1.166 0 0 1 -1.167 1.167h-3.32v3.5l-4.663 -3.5h-0.85'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
    <path
      d='M20.25 3.75H4.417A1.166 1.166 0 0 0 3.25 4.917V16.55a1.2 1.2 0 0 0 1.2 1.2h1.8'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
    ></path>
  </svg>
)

export const NewChatIcon = () => (
  <svg fill='none' viewBox='-1.25 -1.25 24 24'>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      d='M19.484375 16.796875h-9.40625l-5.375 4.03125v-4.03125h-2.6875c-0.7166666666666668 0 -1.34375 -0.6270833333333333 -1.34375 -1.34375v-13.4375c0 -0.7166666666666668 0.6270833333333333 -1.34375 1.34375 -1.34375h17.46875c0.7166666666666668 0 1.34375 0.6270833333333333 1.34375 1.34375v13.4375c0 0.7166666666666668 -0.6270833333333333 1.34375 -1.34375 1.34375Z'
      strokeWidth='2.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      d='M10.705208333333333 5.509392916666666V11.780208333333334'
      strokeWidth='2.5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      d='M13.840625 8.734375H7.569746875'
      strokeWidth='2.5'
    />
  </svg>
)

export const ChatHistoryIcon = () => (
  <svg viewBox='-1.25 -1.25 24 24'>
    <path
      d='M12.09375 19.708333333333336a8.734375 8.734375 0 1 0 -8.734375 -8.734375V11.645833333333334'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.5'
    />
    <path
      d='m0.671875 8.955645833333334 2.6875 2.6875 2.6875 -2.6875'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.5'
    />
    <path
      d='m11.421875 5.5962708333333335 0 6.046875 4.703125 0'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.5'
    />
  </svg>
)

export const CollapseIcon = () => (
  <svg viewBox='0 0 24 24'>
    <path
      d='m0.75 23.249 22.5 -22.5'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='4'
    ></path>
    <path
      d='M23.25 23.249 0.75 0.749'
      fill='none'
      stroke='currentColor'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='4'
    ></path>
  </svg>
)

export const DeleteBinIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='-1 -1 24 24' id='Bin--Streamline-Ultimate'>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M16.5528 20.519216666666665H5.4470075c-0.4207683333333333 0 -0.8243125 -0.16710833333333333 -1.1218441666666665 -0.46465833333333334 -0.2975408333333333 -0.29755 -0.4646858333333333 -0.7010666666666666 -0.4646858333333333 -1.1219083333333333V4.6538433333333336H18.139274999999998V18.93265c0 0.42084166666666667 -0.16710833333333333 0.8243583333333333 -0.46465833333333334 1.1219083333333333s-0.7010666666666666 0.46465833333333334 -1.1218166666666667 0.46465833333333334Z'
      strokeWidth='2'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M8.620159166666665 15.759608333333333v-6.346175'
      strokeWidth='2'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M13.37985 15.759608333333333v-6.346175'
      strokeWidth='2'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M0.6875 4.6538433333333336h20.625'
      strokeWidth='2'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M13.37985 1.4807741666666667H8.620205c-0.4207683333333333 0 -0.8243125 0.16715416666666666 -1.1218441666666665 0.4646858333333333 -0.2975408333333333 0.29753166666666664 -0.4646858333333333 0.7010758333333333 -0.4646858333333333 1.1218533333333334v1.5865391666666666h7.93265V3.067313333333333c0 -0.42077749999999997 -0.16710833333333333 -0.8243216666666666 -0.46465833333333334 -1.1218533333333334 -0.29755 -0.29753166666666664 -0.7010666666666666 -0.4646858333333333 -1.1218166666666667 -0.4646858333333333Z'
      strokeWidth='2'
    />
  </svg>
)

export const SendIcon = () => (
  <svg viewBox='-1 -1 24 24'>
    <path
      d='M0.6875 15.756583333333333 10.514166666666666 5.930833333333333a0.6865833333333333 0.6865833333333333 0 0 1 0.9716666666666667 0l9.826666666666666 9.82575'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)
